import Notifiq from "@/Pages/Notifiq/index.vue";

export default [
  {
    path: "/notifiq/index",
    name: "notifiq.index",
    component: Notifiq,
  },
];
